/**
 * Import Lib & assets
 */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */
import { Svg__print } from "components/svg/svg";

/**
 * styled components
 */

const Container = styled.div`
  ${t.mixins.flex({ justify: "flex-end" })}
  cursor: pointer;
  margin-bottom: 12px;
  ${t.mixins.sm(`
    display: none;
  `)}
`;

/**
 * print component is..
 */

const Button__print = ({ style }) => {
  const onClick = () => {
    window.print();
  };
  return (
    <Container style={style} onClick={onClick}>
      <Svg__print />
    </Container>
  );
};

export default Button__print;

Button__print.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Button__print.defaultProps = {
  style: {},
};

/*
    import Button__print from 'components/button/print/button__print'
    <Button__print />
  */
